import { useEffect, useState } from "react";
import { X } from "lucide-react";
import DistrictNetworkDetail from "./DistrictNetworkDetail";
import DistributorNetworkDetail from "./DistributorNetworkDetail";

const RANGES = [
  { key: "today", label: "Today" },
  { key: "yesterday", label: "Yesterday" },
  { key: "7d", label: "7 days" },
  { key: "30d", label: "30 days" },
  { key: "6m", label: "6 months" },
  { key: "12m", label: "12 months" },
];

export default function NetworkDetailDialog({ view, onClose }) {
  const [range, setRange] = useState("30d");
  const [activeTab, setActiveTab] = useState(view.tab || "network");

  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const closeOnEscape = (event) => { if (event.key === "Escape") onClose(); };
    window.addEventListener("keydown", closeOnEscape);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", closeOnEscape);
    };
  }, [onClose]);

  const heading = view.type === "district" ? "District overview" : "Distributor overview";
  return <div className="network-view-overlay" onMouseDown={(event) => { if (event.target === event.currentTarget) onClose(); }}>
    <section className="network-view-dialog" role="dialog" aria-modal="true" aria-labelledby="network-view-title">
      <header className="network-view-header">
        <div><span>SHAHA GROUP · NETWORK INTELLIGENCE</span><h2 id="network-view-title">{heading}</h2></div>
        <div className="network-view-controls">
          {view.type === "distributor" && <div className="network-view-tabs" role="tablist" aria-label="Distributor view">
            <button type="button" role="tab" aria-selected={activeTab === "network"} className={activeTab === "network" ? "is-selected" : ""} onClick={() => setActiveTab("network")}>Network</button>
            <button type="button" role="tab" aria-selected={activeTab === "stock"} className={activeTab === "stock" ? "is-selected" : ""} onClick={() => setActiveTab("stock")}>Shared stock</button>
          </div>}
          <div className="network-view-period" role="group" aria-label="Order date range">
            {RANGES.map((item) => <button type="button" key={item.key} aria-pressed={range === item.key} className={range === item.key ? "is-selected" : ""} onClick={() => setRange(item.key)}>{item.label}</button>)}
          </div>
          <button className="network-view-close" type="button" title="Close details" aria-label="Close details" onClick={onClose}><X size={18} /></button>
        </div>
      </header>
      <div className="network-view-body">
        {view.type === "district"
          ? <DistrictNetworkDetail key={`${view.id}-${range}`} districtId={view.id} range={range} source="network" />
          : <DistributorNetworkDetail key={`${view.id}-${range}-${activeTab}`} distributorId={view.id} range={range} initialTab={activeTab} />}
      </div>
    </section>
  </div>;
}
